import { logError } from 'services/logging/logging';
import { EMPTY_FIELD } from 'support/helpers/const/const';

export const DEFAULT_CURRENCY = 'EUR';

export const isValidCurrency = (currency: string | undefined | null): currency is string => {
  if (!currency) {
    return false;
  }
  try {
    new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency,
    });
    return true;
  } catch {
    return false;
  }
};
export const formatCurrency = (
  value: number,
  currency: string | undefined | null,
  options: Omit<Intl.NumberFormatOptions, 'currency'> = { maximumFractionDigits: 2 },
) => {
  const validCurrency = isValidCurrency(currency) ? currency : DEFAULT_CURRENCY;
  try {
    return new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: validCurrency,
      ...options,
    }).format(value || 0);
  } catch (e) {
    logError(e);
    return `${value}`;
  }
};

export const formatCurrencyOrEmptyValue = (
  value: number | undefined | null,
  currency: string | undefined,
  transformer: (value: number) => number = (value) => value,
): string => {
  return value != undefined ? formatCurrency(transformer(value), currency) : EMPTY_FIELD;
};

export const getCurrencySymbol = (currency: string | undefined | null) => {
  const validCurrency = isValidCurrency(currency) ? currency : DEFAULT_CURRENCY;
  return (0)
    .toLocaleString(navigator.language, {
      style: 'currency',
      currency: validCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim();
};
